import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import { InputCurrency } from '@/components/ui/InputCurrency';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VEHICLE_SOLD_PRICE_NAME = 'vehicle_sold_price';
export const VEHICLE_SOLD_PRICE_NAME_COMPLEMENTARY =
  'vehicle_sold_price_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const InputVehicleSoldPrice: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? VEHICLE_SOLD_PRICE_NAME_COMPLEMENTARY
      : VEHICLE_SOLD_PRICE_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
        validate: (value) =>
          Number.isNaN(parseFloat(value))
            ? i18n.t('Wartość musi być liczbą.')
            : undefined,
      }}
      render={({ field }) => {
        return (
          <FormItem>
            <FormLabel>{i18n.t('Za ile został sprzedany samochód?')}</FormLabel>
            <FormControl>
              <InputCurrency
                label={i18n.t('Cena sprzedanego samochodu')}
                {...field}
                data-testid="input-vehicle-sold-price"
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};
